import type { ReactNode } from 'react';

/** One labelled value of a tenant's profile, inside a `<dl>`. */
export function Detail({ label, value }: { label: string; value: ReactNode }) {
  return (
    <div className="dg-stack dg-stack--tight">
      <dt className="dg-stat__label">{label}</dt>
      <dd style={{ margin: 0 }}>{value}</dd>
    </div>
  );
}
